import Image from './Image';


Image.install = function(Vue) {
  Vue.component(Image.name, Image);
};

export default Image;
